<div class="container d-flex flex-column align-items-center justify-content-center vh-100">
  <div class="card p-4" style="max-width: 400px;">
    <div class="pin">
      <div class="text-center">
        <h5 class="mb-3">Verifica tu dirección de correo electrónico</h5>
      </div>
      <div class="text-center">
        <p class="text-muted">Para confirmar tu afiliación a Débito Automático Mensual, hemos enviado un código a {{email}}</p>
      </div>
      <div class="my-3">
        <div class="d-flex justify-content-center">
          <input [(ngModel)]="input1" type="number" maxlength="1" (input)="enforceMaxLength($event, 'input2')" (paste)="handlePaste($event)" id="input1" class="form-control text-center mx-1" style="width: 50px;" />
          <input [(ngModel)]="input2" type="number" maxlength="1" (input)="enforceMaxLength($event, 'input3')" (paste)="handlePaste($event)" id="input2" class="form-control text-center mx-1" style="width: 50px;" />
          <input [(ngModel)]="input3" type="number" maxlength="1" (input)="enforceMaxLength($event, 'input4')" (paste)="handlePaste($event)" id="input3" class="form-control text-center mx-1" style="width: 50px;" />
          <input [(ngModel)]="input4" type="number" maxlength="1" (input)="enforceMaxLength($event, 'input5')" (paste)="handlePaste($event)" id="input4" class="form-control text-center mx-1" style="width: 50px;" />
          <input [(ngModel)]="input5" type="number" maxlength="1" (input)="enforceMaxLength($event, 'input6')" (paste)="handlePaste($event)" id="input5" class="form-control text-center mx-1" style="width: 50px;" />
          <input [(ngModel)]="input6" type="number" maxlength="1" (input)="enforceMaxLength($event, 'null')"   (paste)="handlePaste($event)" id="input6" class="form-control text-center mx-1" style="width: 50px;" />
        </div>
      </div>
      <div class="text-center">
        <button (click)="verificarpin()" class="btn btn-danger btn-block mb-3" [disabled]="isButtonDisabled">Continuar</button>
        <app-countdown-timer [minutes]="1" (countdownFinished)="disableButton()"></app-countdown-timer>
        @if (errorcode) {
          <div>
            <label  class="mt-3 text-danger"> Código Incorrecto</label>
          </div>
        }
      </div>
      <!-- <div *ngIf="!isUploadCard"> -->
      <app-confirmationpayment></app-confirmationpayment>
    <!-- </div> -->
  </div>
</div>
</div>
<!-- <div class="container d-flex flex-column align-items-center justify-content-center vh-100"> -->
<!-- </div> -->
